var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
function LinkOverlayContainerComponent(props, ref) {
    const { children, component = 'div' } = props, rest = __rest(props, ["children", "component"]);
    const Component = component;
    return (_jsx(Component, Object.assign({ ref: ref, css: {
            position: 'relative',
            /* Elevate the inner links and abbreviations up */
            'a[href]:not(.ui__link__overlay), abbr[title]': {
                position: 'relative',
                zIndex: 1,
            },
        } }, rest, { children: children })));
}
/**
 * A component that contains a link overlay. Should be used with LinkOverlay.
 *
 * @example
 *<LinkOverlayContainer>
 * <LinkOverlay href='https://www.example.com/'>Link text</LinkOverlay>
 *</LinkOverlayContainer>
 *
 */
export const LinkOverlayContainer = React.forwardRef(LinkOverlayContainerComponent);
